<template>
  <el-card shadow="never">
    <div
      class="d-flex justify-content-between align-items-center flex-row"
      :class="{ 'mb-3': collapse }"
    >
      <div class="flex-grow-1" style="padding-right: 15px;">
        <slot name="header">
          <h6 v-if="title" style="color: #101010;">
            {{ title }}
          </h6>
          <p
            v-if="desc"
            style="font-size:12px;color: #6C6C6C;"
            class="m-0 text-truncate"
          >
            {{ desc }}
          </p>
        </slot>
      </div>

      <div>
        <a style="color: #606266" @click="collapse = !collapse">
          <i
            v-if="collapse"
            class="fa fa-chevron-down"
            :title="$l('btn_collapseDown') || '收起'"
          ></i>
          <i
            v-else
            class="fa fa-chevron-up"
            :title="$l('btn_collapseUp') || '展开'"
          ></i>
        </a>
      </div>
    </div>

    <b-collapse v-model="collapse">
      <slot> </slot>
    </b-collapse>
  </el-card>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    desc: { type: String, default: '' },
  },
  data() {
    return { collapse: true }
  },
}
</script>
